export const LIST_BLOG_CATEGORY = 'LIST_BLOG_CATEGORY';
export const CREATE_BLOG_CATEGORY = 'CREATE_BLOG_CATEGORY';
export const SHOW_BLOG_CATEGORY = 'SHOW_BLOG_CATEGORY';
export const UPDATE_BLOG_CATEGORY = 'UPDATE_BLOG_CATEGORY';
export const DELETE_BLOG_CATEGORY = 'DELETE_BLOG_CATEGORY';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';